import { CheckIcon } from '@phosphor-icons/react'

import { AccountBalanceWallet } from '@assets/svgs/AccountBalanceWallet'
import { CurrencyDollarSimple } from '@assets/svgs/CurrencyDollarSimple'
import { currencyMask } from '@utils/masks/currencyMask'
import { InfoIcon } from '@assets/svgs/InfoIcon'
import { TooltipExplanation } from '@components/shared/TooltipExplanation/inde'
import { TrendingDown } from '@assets/svgs/TrendingDown'
import { TrendingUp } from '@assets/svgs/TrendingUp'
import { PreviewCard } from '@pages/Consumption/components/PreviewCard'

import type { BudgetPreviewsProps } from './types'

const BONUS_WEEK_COLORS = ['#C2F0D7', '#A6E2C1', '#89D3AA', '#6DC593', '#51B77D']
const BUDGET_BORDER = '#7B8794'

export const budgetPreviews = ({ data }: BudgetPreviewsProps) => {
  if (!data) return []

  const week = data.currentPreviewNumber ?? 3
  const previewBorderColor = BONUS_WEEK_COLORS[week - 1] ?? BONUS_WEEK_COLORS[2]

  return [
    <PreviewCard
      isBudget
      borderColor={BUDGET_BORDER}
      label="Budget"
      percentageValue={`${data.budgetPercentage.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(data.budgetAmount.toFixed(2))}
      icon={<AccountBalanceWallet />}
      bottomText="Orçamento aprovado"
      infoIcon={
        <TooltipExplanation
          data={[{ label: 'Budget (%) = ', text: '(Orçamento (R$) ÷ Budget de Consumo (R$)) × 100' }]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      isBudget
      borderColor={previewBorderColor}
      label={!data.currentPreviewNumber ? 'Prévia' : `Prévia ${data.currentPreviewNumber}ª semana`}
      percentageValue={`${data.previewCurrentPercentage.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(data.previewCurrentAmount.toFixed(2))}
      icon={<CurrencyDollarSimple />}
      bottomText="Previsão Atual"
      infoIcon={
        <TooltipExplanation
          data={[
            { label: '', text: 'Se Ajuste (%) for branco:' },
            { label: 'Prévia (%) = ', text: 'Média Bonif. (%), caso contrário' },
            { label: 'Prévia (%) = ', text: 'Ajuste (%)' },
            { label: 'Prévia (R$) = ', text: 'Prévia (%) x Total Consumo (R$)' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      label="Desvio"
      borderColor={BONUS_WEEK_COLORS[BONUS_WEEK_COLORS.length - 1]}
      percentageValue={`${data.deviationPercentage.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(data.deviationValue.toFixed(2))}
      isNegative={data.deviationPercentage < 0}
      icon={
        data.deviationPercentage === 0 ? (
          <CheckIcon size={24} />
        ) : data.deviationPercentage < 0 ? (
          <TrendingDown />
        ) : (
          <TrendingUp />
        )
      }
      bottomText={
        data.deviationPercentage === 0
          ? 'Sem desvio'
          : data.deviationPercentage < 0
            ? 'Abaixo do Budget'
            : 'Acima do Budget'
      }
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'Desvio (%) = ', text: 'Prévia (%) - Budget (%)' },
            { label: 'Desvio (R$) = ', text: 'Prévia (R$) - Budget (R$)' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />
  ]
}
